import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import RubricRate from '../rubric/RubricRate';

const styles = {
    paper: {
        maxHeight: "50%"
    },
    list: {
        width: 250,
    },
    fullList: {
        width: 'auto',
    },
};

class ArtifactRateDrawer extends React.Component {
    state = {
        top: false,
        left: false,
        bottom: false,
        right: false,
    };

    toggleDrawer = (side, open) => () => {
        this.setState({
            [side]: open,
        });
    };

    render() {
        const {classes, isReviewed, color, artifactId} = this.props;

        if (isReviewed)
            return (
                <div>
                    <Button color={color} onClick={this.toggleDrawer('bottom', true)}>Rate Artifact</Button>
                    <Drawer
                        classes={{paper: classes.paper}}
                        anchor="bottom"
                        open={this.state.bottom}
                        onClose={this.toggleDrawer('bottom', false)}
                    >
                        <div
                            tabIndex={0}
                            role="button"
                            // onClick={this.toggleDrawer('bottom', false)}
                            // onKeyDown={this.toggleDrawer('bottom', false)}
                        >
                            <RubricRate onCancel={this.toggleDrawer('bottom', false)} artifactId={artifactId}/>
                        </div>
                    </Drawer>
                </div>
            );
        else
            return null;
    }
}

ArtifactRateDrawer.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ArtifactRateDrawer);
